import React from 'react';
import { WifiOff } from 'lucide-react';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const OfflineModeSettings = () => {
  return (
    <>
      <PageBreadcrumb />
      <PageHeader 
        title="Offline Mode Settings"
        description="Configure offline capabilities and data synchronization"
      />
      <div className="page-container">

        <div className="card-cam" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', padding: '48px 24px' }}>
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: 'var(--component-radius)',
              background: '#F3E8FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              color: '#8B5CF6'
            }}>
              <WifiOff size={48} />
            </div>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '600',
              color: 'var(--text-heading)',
              margin: '0 0 16px 0',
              fontFamily: 'var(--font-family)'
            }}>Offline Capabilities</h2>
            <p style={{
              color: 'var(--text-body)',
              margin: '0 0 32px 0',
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto',
              fontFamily: 'var(--font-family)'
            }}>
              Configure offline mode with automatic data synchronization. 
              This feature will be available in v2.0.
            </p>
            
            <div style={{
              background: '#FEF3C7',
              border: '1px solid #FCD34D',
              borderRadius: 'var(--component-radius)',
              padding: '16px',
              marginBottom: '24px',
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>
              <p style={{
                color: '#92400E',
                fontSize: '14px',
                margin: 0,
                fontFamily: 'var(--font-family)'
              }}>
                <strong>Coming Soon:</strong> Offline mode with automatic sync, 
                data caching, and conflict resolution.
              </p>
            </div>

            <button className="btn-cam" style={{ margin: '0 auto', background: '#8B5CF6' }}>
              <WifiOff size={20} style={{ marginRight: '8px' }} />
              Configure Offline Mode
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfflineModeSettings;
